var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTabStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 6.44772 1.44772 6 2 6H14C14.5523 6 15 6.44772 15 7V18C15 18.5523 14.5523 19 14 19H2C1.44772 19 1 18.5523 1 18V7Z",
    fill: "white",
    stroke: "#CCD4D8",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6L11 6ZM3 6C3 6.55228 3.44771 7 4 7C4.55228 7 5 6.55228 5 6L3 6ZM5 4.8009C5 3.3015 6.29442 2 8 2L8 1.27146e-07C5.2873 -1.10006e-07 3 2.10194 3 4.8009L5 4.8009ZM8 2C9.70558 2 11 3.3015 11 4.8009L13 4.80091C13 2.10194 10.7127 3.64298e-07 8 1.27146e-07L8 2ZM11 4.8009L11 6L13 6L13 4.80091L11 4.8009ZM3 4.8009L3 6L5 6L5 4.8009L3 4.8009Z",
    fill: "#CCD4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTabStore);
export default __webpack_public_path__ + "static/media/ic_tab_store.6351e3401b802f986d5e5b248c1821ea.svg";
export { ForwardRef as ReactComponent };